import ModelAgent from "@models/agents/ModelAgent";
import { Ref, ref } from "vue";
import LightPaymentPidResponseError from "@models/responses/light-payment-pid/LightPaymentPidResponseError";
import ServiceAgents from "@/services/v2/data/service-agents/ServiceAgents";
import PaymentService from "@/services/operations/payment/PaymentService";

export default class ViewPaymentCreateAgentsController {
    private static _instance: ViewPaymentCreateAgentsController | null = null;
    private readonly _agents: Ref<ModelAgent[]>;
    private _agent: Ref<ModelAgent | null> = ref(null);
    private _amount: Ref<number | null> = ref(null);
    public paymentError: Ref<LightPaymentPidResponseError | null>;
    public paymentErrorWasShowed: Ref<boolean> = ref(false);
    private _paymentService: PaymentService;

    private _serviceAgents: ServiceAgents;

    public constructor() {
        this._serviceAgents = ServiceAgents.of();
        this._paymentService = PaymentService.of();

        this._agents = this._serviceAgents.agents;
        this.paymentError = this._paymentService.paymentError;
    }

    public static of() {
        if (this._instance === null) this._instance = new ViewPaymentCreateAgentsController();
        return this._instance;
    }

    get amount(): Ref<number | null> {
        return this._amount;
    }

    set amount(value: Ref<number | null>) {
        this._amount = value;
    }

    get agent(): Ref<ModelAgent | null> {
        return this._agent;
    }

    set agent(value: Ref<ModelAgent | null>) {
        this._agent = value;
    }

    get agents(): Ref<ModelAgent[]> {
        return this._agents;
    }

    selectPurchaseAgent(agent: ModelAgent | null) {
        this._serviceAgents.selectedPurchaseAgent = agent;
    }

    async fetchAndSetAgents() {
        await this._serviceAgents.fetchAgentsAvailableForPurchase();
    }
}
